import { useState } from "react";

export default function NewComment({
  currentUser,
  handleSubmit,
  placeholder = "Adicionar comentário...",
  initialText = "",
  isEdit = false,
  buttonText,
}) {
  const [text, setText] = useState(initialText);
  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(text);
    setText("");
  };

  return (
    <form
      className={isEdit ? "edit-comment" : "new-comment-container"}
      onSubmit={onSubmit}
    >
      <textarea
        className="new-comment"
        placeholder={placeholder}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
        }}
      />
      {!isEdit && (
        <img
          className="new-comment-avatar"
          //src={`/images/avatars/image-${currentUser.username}.png`}
          src={`${currentUser.image.png}`}
          alt={currentUser.username}
        />
      )}
      {!isEdit && currentUser?.permission && currentUser?.permission === "admin" ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <button className="submit submit-comment" type="submit" style={{
            width: "80%",
            gridColumn: '3',
            gridRow: '1',
            backgroundColor: "rgb(33, 160, 33)"
          }}>
            Aprovar
          </button>
          <button className="submit submit-comment" type="submit" style={{
            width: "80%",
            gridColumn: '3',
            gridRow: '2',
            backgroundColor: "rgb(243, 57, 57)"
          }}>
            Revisar
          </button>
        </div>
      ) : (
        <button className="submit submit-comment" type="submit" style={{ gridColumn: isEdit ? '2' : '3' }}>
          {buttonText}
        </button>
      )}
    </form>
  );
}
